import { tWithKeyAttr as t } from "../../i18nHelper";
import styles from "./myAccount.module.css";
import AccountDetails from "../modals/accountDetailsModal/accountDetails";
import BackArrowButton from "../backArrowButton/backArrowButton";
import { useNavigate, useSearchParams } from "react-router-dom";

interface AccountCategory {
  id: string;
  title: string;
  description: string;
  icon?: string;
}

export const accountCategories: AccountCategory[] = [
  // {
  //   id: 'invoices',
  //   title: 'INVOICES',
  //   description: 'VIEW_AND_DOWNLOAD_INVOICES',
  // },
  {
    id: 'payment',
    title: 'PAYMENT_DETAILS',
    description: 'CREDIT_CARD_UPDATE_PAYMENT',
  },
  {
    id: 'subscription',
    title: 'SUBSCRIPTION',
    description: 'CURRENT_SUBSCRIPTION_DETAILS',
  },
  {
    id: 'plan-usage',
    title: 'PLAN_USAGE',
    description: 'PLAN_USAGE_DESC',
  },
  {
    id: 'buy-credits',
    title: 'BUY_CREDITS',
    description: 'BUY_CREDITS_DESC',
  },
  {
    id: 'seat-packs',
    title: 'SEAT_PACKS',
    description: 'SEAT_PACKS_DESC',
  },
  {
    id: 'credit-purchases',
    title: 'CREDIT_PURCHASES_HISTORY',
    description: 'CREDIT_PURCHASES_HISTORY_DESC',
  },
  // {
  //   id: 'services',
  //   title: 'SERVICES',
  //   description: 'ACTIVE_SERVICES_MANAGEMENT',
  // },
  // {
  //   id: 'login-history',
  //   title: 'LOGIN_HISTORY',
  //   description: 'VIEW_ACCOUNT_LOGIN_HISTORY',
  // },
  // {
  //   id: 'system-messages',
  //   title: 'SYSTEM_MESSAGES',
  //   description: 'IMPORTANT_NOTICES_UPDATES',
  // },
];


function MyAccount() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') ?? 'payment';

  return (
    <section className={styles.page}>
      <div className={styles.pageHeader}>
        <BackArrowButton
          text={t('PREVIOUS_SCREEN')}
          onClick={() => navigate('/management')}
        />
        <h1 className="title title_blue">{t('MY_ACCOUNT')}</h1>
      </div>
      <AccountDetails
        activeTab={activeTab}
        onClose={() => navigate('/management')}
      />
    </section>
  );
}

export default MyAccount;
